import _ from 'lodash'

export default (props, { data, loading }) => {
  if (loading) return true
  if (!data) return false

  return _.get(props, 'game.currentTurn.id') === _.get(data, 'respond.id')
}
